/**
 * Fixed UI copy of „Zmena hesla“ (Figma 60322:19374, mobile 60459:89796). Words the core dictionary
 * has letter for letter (Nové heslo, Aktuálne heslo, Zmeniť heslo, Heslo bolo úspešne zmenené …) are
 * read with `t()`; wording shared with the forgotten-password dialog comes from `RESET_COPY`.
 */
export const PASSWORD_COPY = {
  repeat: 'Zopakovať nové heslo',
  match: 'Heslá sa zhodujú',
  failed: 'Heslo sa nepodarilo zmeniť. Skúste to znova.',
  forgot: {
    title: 'Nepamätáte si aktuálne heslo?',
    text: (email: string) => `Pošleme vám odkaz na nastavenie nového hesla na ${email}.`,
    sent: (email: string) => `Odkaz na nastavenie nového hesla sme poslali na ${email}.`,
    failed: 'Odkaz sa nepodarilo odoslať. Skúste to znova.',
  },
} as const;
